import Component from '../app/component.js'

export default class extends Component {
  constructor (el) {
    super(el)
    this.data = {}
  }

  init () {
    // document.addEventListener('requestOverlay.success', () => {
    //   this.refs.successMessage.classList.add('ui-message--active');
    //   setTimeout(() => {
    //     this.refs.successMessage.classList.remove('ui-message--active');
    //   }, 7000);
    // })
  }
}
